import axios from '@/plugins/axios'
import { Module } from 'vuex'
import router from '../router'

export interface ImageLibrary {
    username: string
    token: string
}

const imageLibraryModule: Module<any, any> = {
    state: {
        images: [],
        totalRows: 0,
    },

    actions: {
        async GetImages({ commit }) {
            const response = {
                data: [
                    {
                        id: 0,
                        date: '2021-09-12',
                        url: '/images/img-06.jpg',
                    },
                    {
                        id: 1,
                        date: '2021-09-12',
                        url: '/images/img-06.jpg',
                    },
                    {
                        id: 2,
                        date: '2021-09-12',
                        url: '/images/img-06.jpg',
                    },
                    {
                        id: 3,
                        date: '2021-09-12',
                        url: '/images/img-06.jpg',
                    },
                    {
                        id: 4,
                        date: '2021-09-12',
                        url: '/images/img-06.jpg',
                    },
                    {
                        id: 5,
                        date: '2021-09-12',
                        url: '/images/img-06.jpg',
                    },
                    {
                        id: 6,
                        date: '2021-09-12',
                        url: '/images/img-06.jpg',
                    },
                ],

                totalRows: 7,
            }

            commit('setImages', response.data)
            commit('setTotalRows', response.totalRows)

            return response
        },
    },

    mutations: {
        setImages(state: any, images) {
            state.images = images
        },
        setTotalRows(state: any, rows) {
            state.totalRows = rows
        },
    },
}

export default imageLibraryModule
